export default __webpack_public_path__ + "static/media/cargo-home-video-button-1024x427.9d2335a3.jpeg";